import RecepcionService from "@/services/wms/RecepcionService";
import ContenedorService from "@/services/wms/ContenedorService";
import RutaService from "@/services/wms/RutaService";

const fetch = (context, params) => {
  return RecepcionService.fetch(params)
    .then(res => {
      context.commit('RECEPCIONES', res.data);
    });
};

const contenedores = (context, params) => {
  return ContenedorService.fetch(params)
    .then(res => {
      context.commit('CONTENEDORES', res.data);
    });
};

const rutas = (context, params) => {
  return RutaService.fetch(params)
    .then(res => {
      context.commit('RUTAS', res.data);
    });
};

export default {
  fetch,
  contenedores,
  rutas
  

};